<template>
  <div id="list-skill-sheet">
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <CForm class="create_form" @submit.prevent="handleSubmit(saveSkillSheet)">
        <CRow class="skill-title">
          <span class="label-skill">{{ $t("skill.lable_skill") }}</span>
        </CRow>
        <CRow>
          <CCol class="old-skill">
            <CCol
              class="old-skill-mobile"
              v-for="(value, index) in skillSheets"
              :key="index"
            >
              <CRow class="type-skill">
                <CCol col="12" class="form-field">
                  <label class="type-skill-mobile">
                    {{ $t("skill.type") }}
                  </label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('skill.type')"
                  >
                    <CCol class="d-flex">
                      <CInput
                        type="text"
                        v-model="value.skillType"
                        class="name-skill-input"
                      />
                      <span
                        @click="deleteOldTypeSkill(index)"
                        class="delete-btn"
                      >
                        <CIcon name="cilTrash" class="delete-btn-icon" />
                      </span>
                    </CCol>
                    <div v-if="errors.length > 0" class="validate">
                      <span class="required">{{ errors[0] }}</span>
                    </div>
                  </ValidationProvider>
                </CCol>
              </CRow>
              <CRow class="name-skill">
                <CCol
                  col="12"
                  class="input"
                  v-for="(v, k) in value.skillName"
                  :key="k"
                >
                  <CRow>
                    <CCol col="12 name-sikll-mobile">
                      <label>
                        {{ $t("skill.name") }}
                      </label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :name="$t('skill.name')"
                      >
                        <CCol class="d-flex">
                          <CInput
                            ref="aa"
                            type="text"
                            v-model="v.name"
                            class="name-skill-input"
                          />
                          <span
                            @click="deleteOldInfoNameSkill(index, k)"
                            class="delete-btn"
                          >
                            <CIcon name="cilTrash" class="delete-btn-icon" />
                          </span>
                        </CCol>
                        <div v-if="errors.length > 0" class="validate">
                          <span class="required">{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                    </CCol>
                  </CRow>
                </CCol>
                <CCol col="12" class="btn-add-new">
                  <label @click="addInformationNameSKill(index)">{{
                    "+ " + $t("skill.lable_add_skill_name")
                  }}</label>
                </CCol>
              </CRow>
            </CCol>
            <div class="btn-add-new">
              <label @click="addInformation()">{{
                "+ " + $t("skill.lable_add_skill_type")
              }}</label>
            </div>
          </CCol>
        </CRow>
        <CRow class="button">
          <button class="btn btn-success update" type="submit">
            {{ $t("skill.lable_save") }}
          </button>
          <button
            type="button"
            class="btn btn-secondary cancel"
            @click="cancel()"
          >
            {{ $t("skill.lable_cancel") }}
          </button>
        </CRow>
      </CForm>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  metaInfo() {
    return {
      title: this.$t("page_title.page_list_skill_sheet"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  components: {
    ValidationObserver,
    ValidationProvider
  },
  computed: {
    ...mapGetters({
      skillSheets: "skillsheet/skillSheets"
    })
  },

  async created() {
    await this.getLists();
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),

    getLists() {
      this.$store.dispatch("skillsheet/fetchSkillSheet");
    },
    addInformationNameSKill(key) {
      this.skillSheets[key]["skillName"].push({ name: "" });
      let listSkill = document.querySelectorAll(".old-skill input");
      for (let i = 0; i < listSkill.length; i++) {
        listSkill[i].focus();
        listSkill[i].blur();
      }
    },
    deleteOldInfoNameSkill(key, code) {
      this.skillSheets[key]["skillName"].splice(code, 1);
      if (this.skillSheets[key]["skillName"].length === 0) {
        this.skillSheets.splice(key, 1);
      }
    },
    addInformation() {
      var skillItem = {
        skillType: "",
        skillName: [{ name: "" }]
      };
      let listSkill = document.querySelectorAll(".old-skill input");
      for (let i = 0; i < listSkill.length; i++) {
        listSkill[i].focus();
        listSkill[i].blur();
      }
      this.skillSheets.push(skillItem);
    },
    deleteOldTypeSkill(key) {
      this.skillSheets.splice(key, 1);
    },
    async saveSkillSheet() {
      var save = true;
      for (let k in this.skillSheets) {
        if (!this.skillSheets[k]["skillType"]) {
          save = false;
        }
        if (this.skillSheets[k]["skillType"]) {
          for (let j in this.skillSheets[k]["skillName"]) {
            if (!this.skillSheets[k]["skillName"][j]["name"]) {
              save = false;
            }
          }
        }
      }
      if (save) {
        this.setLoading(true);
        await this.$store
          .dispatch("skillsheet/createSkillSheet", this.skillSheets)
          .then(() => {
            let message = this.$t("overtime.message_create_success");
            this.$toast(message, null, 2000, "b-toaster-top-center", "success");
            this.setLoading(false);
          })
          .catch(() => {
            this.setLoading(false);
          });
      }
    },
    cancel() {
      this.$confirm(
        this.$t("popup.employee.label_popup_title"),
        this.$t("skill.lable_skill"),
        this.$t("popup.employee.label_confirm_button"),
        this.$t("popup.employee.label_cancel_button"),
        "danger"
      ).then(value => {
        if (value) {
          this.$router.push({ path: "/" });
        }
      });
    }
  }
};
</script>

<style scoped>
#list-skill-sheet {
  margin: auto;
  width: 55%;
  border: 1px solid #d8dbe0;
  background-color: #fff;
  padding: 0.75rem 1.25rem;
  margin-bottom: 30px;
}
.skill-title {
  margin-right: 0;
  margin-left: 0;
}
.type-skill {
  width: 100%;
}
.label-skill {
  margin-bottom: 4%;
  font-size: 22px;
  font-weight: 600;
}
.name-skill {
  margin-left: 1rem;
}
.delete-btn-icon {
  color: red;
}
.name-skill-input {
  width: 90%;
  margin-right: 5%;
}
.button {
  display: flex;
  justify-content: center;
  margin: 15px 0;
}
.update {
  margin-right: 10px;
}
.btn-add-new label {
  color: #f6ab5f;
  font-size: 1rem;
  cursor: pointer;
}
.delete-btn {
  cursor: pointer;
  margin-top: 0.2rem;
}
label {
  font-weight: 600;
}
.validate {
  text-align: left;
  margin-left: 1rem;
  margin-top: -10px;
  color: #dc3545;
  margin-bottom: 10px;
}
@media screen and (max-width: 767px) {
  div#list-skill-sheet {
    width: 100%;
    padding: 0.75rem 0;
  }
  .old-skill-mobile {
    padding: 0;
  }
  .label-skill {
    margin-left: 0.3rem;
  }
  .type-skill-mobile {
    margin-left: 0.5rem;
  }
  .btn-add-new {
    margin: 0.5rem 0 0 1rem;
  }
  .name-sikll-mobile {
    margin-top: 0.5rem;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  #list-skill-sheet {
    width: 100%;
  }
}
</style>
